/**
 * COLORS
 */
export const K_COLORS_DARK_NAVY = "#000011";
export const K_COLORS_LIGHT_GREY = "#E6E6E6";
export const K_COLORS_LIGHT_BLUE = "#9EA8C7";
export const K_COLORS_CRIMSON_RED = "#821f03";
export const K_COLORS_WHITE = "#FFFFFF";
export const K_COLORS_SMOKE_GREY = "#808080";
export const K_COLORS_DARK_GREY = "#3E4456";
export const K_COLORS_NIGHT_GREY = "#2B2E36";
export const K_COLORS_DARK_BLUE = "#091628";

/**
 * LETTER SPACING
 */
export const K_LETTER_SPACING = "1.25px";

/**
 * MOBILE WIDTH BREAKPOINT
 */
export const K_MOBILE_SIZE = 1000;
